<template>
  <master-page>
    <v-card class="mt-4 mb-4">
      <v-card-title class="primary white--text">
        <v-icon left color="white">mdi-file-export-outline</v-icon>
        <span class="title font-weight-light">Exportação Contábil</span>
        <v-spacer/>
        <v-chip v-if="layout.padrao" small color="white" text-color="primary">Layout padrão</v-chip>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-row>
          <v-col cols="12" lg="4">
            <v-card outlined height="100%">
              <v-card-title class="subtitle-1"><v-icon left>mdi-view-grid-plus</v-icon>Layouts</v-card-title>
              <v-card-text>
                <v-select v-model="layoutSelecionadoId" :items="layouts" item-value="id" item-text="nome"
                  label="Layout salvo" clearable dense outlined @change="SelecionarLayout"/>
                <v-text-field v-model="layout.nome" label="Nome do layout" :counter="100" maxlength="100" dense outlined/>
                <div class="d-flex flex-wrap layout-gap">
                  <v-btn small outlined color="primary" @click="NovoLayout"><v-icon left small>mdi-plus</v-icon>Novo</v-btn>
                  <v-btn small color="primary" @click="SalvarLayout"><v-icon left small>mdi-content-save</v-icon>Salvar</v-btn>
                  <v-btn small outlined color="primary" @click="SalvarComo"><v-icon left small>mdi-content-duplicate</v-icon>Salvar como</v-btn>
                  <v-btn small outlined color="error" :disabled="!layout.id" @click="ExcluirLayout"><v-icon left small>mdi-delete</v-icon>Excluir</v-btn>
                  <v-btn small outlined color="primary" :disabled="!layout.id || layout.padrao" @click="DefinirPadrao"><v-icon left small>mdi-star</v-icon>Definir padrão</v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" lg="8">
            <v-card outlined height="100%">
              <v-card-title class="subtitle-1"><v-icon left>mdi-filter-outline</v-icon>Filtros</v-card-title>
              <v-card-text>
                <v-form ref="formFiltros" v-model="filtrosValidos">
                  <v-row>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="filtros.dataInicial" type="date" label="Período inicial" :rules="regrasObrigatorio" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="filtros.dataFinal" type="date" label="Período final" :rules="regrasObrigatorio" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-autocomplete v-model="filtros.bancoId" :items="bancos" item-value="id" item-text="codigoNome" label="Conta bancária" clearable dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-autocomplete v-model="filtros.projetoId" :items="projetos" item-value="id" item-text="codigoNome" label="Projeto" clearable dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select v-model="filtros.tipoLancamento" :items="tiposLancamento" label="Tipo de lançamento" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-select v-model="filtros.modoExportacao" :items="modosExportacao" label="Modo de exportação" dense outlined/>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card outlined>
              <v-card-title class="subtitle-1"><v-icon left>mdi-file-cog-outline</v-icon>Configuração do arquivo</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6"><v-select v-model="layout.formatoPreferido" :items="formatos" label="Formato preferido" dense outlined/></v-col>
                  <v-col cols="12" sm="6"><v-select v-model="layout.separador" :items="separadores" label="Separador" dense outlined/></v-col>
                  <v-col cols="12" sm="6"><v-select v-model="layout.formatoData" :items="formatosData" label="Formato da data" dense outlined/></v-col>
                  <v-col cols="12" sm="6"><v-select v-model="layout.separadorDecimal" :items="separadoresDecimais" label="Separador decimal" dense outlined/></v-col>
                  <v-col cols="12"><v-switch v-model="layout.cabecalho" label="Incluir cabeçalho" inset/></v-col>
                </v-row>
                <v-alert dense outlined type="info" class="mb-0">O formato preferido é salvo no layout, mas os três tipos de arquivo permanecem disponíveis.</v-alert>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12">
            <v-card outlined height="100%">
              <v-card-title class="subtitle-1">
                <v-icon left>mdi-table-column</v-icon>Configuração das colunas
                <v-spacer/>
                <v-btn x-small outlined color="primary" class="mr-2" :disabled="possuiColunaSequencial" @click="AdicionarColuna('sequencial')"><v-icon left x-small>mdi-counter</v-icon>Sequencial</v-btn>
                <v-btn x-small outlined color="primary" class="mr-2" @click="AdicionarColuna('vazia')"><v-icon left x-small>mdi-table-column-plus-after</v-icon>Coluna vazia</v-btn>
                <span class="caption grey--text">Arraste ou use as setas</span>
              </v-card-title>
              <v-card-text>
                <v-data-table :headers="headersConfiguracaoColunas" :items="colunasOrdenadas" item-key="identificador"
                  :items-per-page="-1" hide-default-footer disable-sort dense class="colunas-tabela">
                  <template v-slot:item="{ item, index }">
                    <tr @dragover.prevent @drop="FinalArraste(index)">
                      <td class="text-center">
                        <span draggable="true" class="drag-handle" @dragstart="InicioArraste(index, $event)" @dragend="indiceArraste = null">
                          <v-icon small>mdi-drag</v-icon>
                        </span>
                      </td>
                      <td>
                        <div class="font-weight-medium">{{ NomeTipoColuna(item) }}</div>
                        <div v-if="item.tipo === 'dados'" class="caption grey--text text--darken-1">{{ NomeCampo(item.campo) }}</div>
                      </td>
                      <td>
                        <v-text-field v-model="item.cabecalhoPersonalizado" maxlength="100" dense outlined hide-details
                          aria-label="Cabeçalho exportado" @input="LimparVisualizacao"/>
                      </td>
                      <td class="text-center">
                        <v-switch v-model="item.exibir" class="coluna-switch" dense hide-details @change="LimparVisualizacao"/>
                      </td>
                      <td class="text-no-wrap text-right">
                        <v-btn icon x-small :disabled="index === 0" :aria-label="`Subir ${NomeTipoColuna(item)}`" @click="MoverColuna(index, -1)"><v-icon small>mdi-chevron-up</v-icon></v-btn>
                        <v-btn icon x-small :disabled="index === colunasOrdenadas.length - 1" :aria-label="`Descer ${NomeTipoColuna(item)}`" @click="MoverColuna(index, 1)"><v-icon small>mdi-chevron-down</v-icon></v-btn>
                        <v-btn v-if="item.tipo !== 'dados'" icon x-small color="error" :aria-label="`Remover ${NomeTipoColuna(item)}`"
                          @click.stop="RemoverColuna(item.identificador)"><v-icon small>mdi-delete</v-icon></v-btn>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-card outlined class="mt-3">
          <v-card-title class="subtitle-1">
            <v-icon left>mdi-table-eye</v-icon>Pré-visualização
            <v-spacer/><span v-if="visualizacao.totalRegistros !== null" class="caption">{{ visualizacao.quantidadeExibida }} de {{ visualizacao.totalRegistros }} registros</span>
          </v-card-title>
          <v-card-text>
            <v-data-table :headers="headersVisualizacao" :items="visualizacao.linhas" :items-per-page="20" hide-default-footer dense
              :no-data-text="visualizacaoExecutada ? 'Nenhum lançamento encontrado.' : 'Clique em Visualizar para carregar os primeiros registros.'" class="elevation-1"/>
          </v-card-text>
        </v-card>
      </v-card-text>

      <v-card-actions class="px-4 pb-4 flex-wrap layout-gap">
        <v-btn color="secondary" @click="Visualizar"><v-icon left>mdi-eye</v-icon>Visualizar</v-btn>
        <v-spacer/>
        <v-btn color="success" @click="GerarArquivo('xlsx')"><v-icon left>mdi-file-excel</v-icon>Gerar Excel</v-btn>
        <v-btn color="primary" @click="GerarArquivo('csv')"><v-icon left>mdi-file-delimited</v-icon>Gerar CSV</v-btn>
        <v-btn color="primary" outlined @click="GerarArquivo('txt')"><v-icon left>mdi-file-document-outline</v-icon>Gerar TXT</v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialogInconsistencias" width="95vw" max-width="1200">
      <v-card>
        <v-card-title class="error white--text">Inconsistências contábeis</v-card-title>
        <v-card-text class="pt-4" style="overflow-x:auto">
          <p>Corrija as contas abaixo antes de visualizar ou exportar.</p>
          <v-data-table class="inconsistencias-tabela" :headers="headersInconsistencias" :items="inconsistencias" dense :items-per-page="-1" hide-default-footer/>
        </v-card-text>
        <v-card-actions><v-spacer/><v-btn text color="primary" @click="dialogInconsistencias = false">Fechar</v-btn></v-card-actions>
      </v-card>
    </v-dialog>

    <v-overlay :value="carregando"><v-progress-circular indeterminate size="64"/></v-overlay>
  </master-page>
</template>

<script>
import ExportacaoContabilService from '@/core/services/financeiro/ExportacaoContabilService';
import BancoService from '@/core/services/financeiro/BancoService';
import ProjetoService from '@/core/services/projetos/ProjetoService';

const COLUNAS = [
  ['Organizacao', 'Organização'], ['Data', 'Data'], ['NumeroDocumento', 'Número do Documento'], ['Historico', 'Histórico'],
  ['CpfCnpj', 'CPF/CNPJ'], ['Favorecido', 'Favorecido'], ['ContaContabilDebito', 'Conta Contábil Débito'],
  ['ContaContabilCredito', 'Conta Contábil Crédito'], ['CodigoReduzidoDebito', 'Código Reduzido Débito'],
  ['CodigoReduzidoCredito', 'Código Reduzido Crédito'], ['ContaGerencial', 'Conta Gerencial'],
  ['Projeto', 'Projeto'], ['Banco', 'Banco'], ['Valor', 'Valor'], ['Observacoes', 'Observações']
];
const TIPO_DADOS = 'dados';
const TIPO_SEQUENCIAL = 'sequencial';
const TIPO_VAZIA = 'vazia';

export default {
  data: () => ({
    service: new ExportacaoContabilService(),
    carregando: false,
    filtrosValidos: true,
    regrasObrigatorio: [v => !!v || 'Campo obrigatório'],
    layouts: [],
    layoutSelecionadoId: null,
    layout: {},
    filtros: { dataInicial: '', dataFinal: '', bancoId: null, projetoId: null, tipoLancamento: 'todos', modoExportacao: 'analitico' },
    bancos: [], projetos: [], indiceArraste: null,
    visualizacao: { colunas: [], linhas: [], quantidadeExibida: 0, totalRegistros: null },
    visualizacaoExecutada: false,
    dialogInconsistencias: false,
    inconsistencias: [],
    tiposLancamento: [{text:'Todos',value:'todos'},{text:'Receitas',value:'receitas'},{text:'Despesas',value:'despesas'},{text:'Transferências',value:'transferencias'}],
    modosExportacao: [{text:'Analítico',value:'analitico'},{text:'Sintético',value:'sintetico'}],
    formatos: [{text:'Excel (.xlsx)',value:'xlsx'},{text:'CSV',value:'csv'},{text:'TXT',value:'txt'}],
    separadores: [{text:'Ponto e vírgula (;)',value:';'},{text:'Vírgula (,)',value:','},{text:'TAB',value:'\t'}],
    formatosData: ['dd/MM/yyyy','yyyy-MM-dd'],
    separadoresDecimais: [{text:'Vírgula',value:','},{text:'Ponto',value:'.'}],
    headersConfiguracaoColunas: [
      {text:'',value:'arrastar',sortable:false,align:'center',width:48},
      {text:'Tipo / origem',value:'tipo',sortable:false,width:240},
      {text:'Cabeçalho exportado',value:'cabecalhoPersonalizado',sortable:false,width:480},
      {text:'Exibir',value:'exibir',sortable:false,align:'center',width:90},
      {text:'Ações',value:'acoes',sortable:false,align:'end',width:130}
    ],
    headersInconsistencias: [
      {text:'Lançamento',value:'lancamentoId'},{text:'Data',value:'data'},{text:'Histórico',value:'historico'},
      {text:'Lado',value:'lado'},{text:'Conta Gerencial',value:'contaGerencial'},{text:'Projeto',value:'projeto'},
      {text:'Classificador',value:'classificador'},{text:'Conta',value:'conta'},{text:'Motivo',value:'motivo'}
    ]
  }),
  computed: {
    colunasOrdenadas(){ return (this.layout.colunas || []).slice().sort((a,b) => a.ordem - b.ordem); },
    possuiColunaSequencial(){ return (this.layout.colunas || []).some(x => x.tipo === TIPO_SEQUENCIAL); },
    headersVisualizacao(){ return (this.visualizacao.colunas || []).map(coluna => ({ text: coluna.cabecalho, value: coluna.identificador, sortable: false })); }
  },
  watch: {
    filtros: { deep: true, handler(){ this.LimparVisualizacao(); } },
    'layout.formatoPreferido'(){ this.LimparVisualizacao(); },
    'layout.separador'(){ this.LimparVisualizacao(); },
    'layout.formatoData'(){ this.LimparVisualizacao(); },
    'layout.separadorDecimal'(){ this.LimparVisualizacao(); },
    'layout.cabecalho'(){ this.LimparVisualizacao(); },
    'layout.colunas': { deep: true, handler(){ this.LimparVisualizacao(); } }
  },
  methods: {
    LayoutPadrao(){
      return { id:0, nome:'', padrao:false, formatoPreferido:'csv', separador:';', formatoData:'dd/MM/yyyy', separadorDecimal:',', cabecalho:true,
        colunas: COLUNAS.map((item,index) => ({identificador:item[0],tipo:TIPO_DADOS,campo:item[0],cabecalhoPersonalizado:item[1],exibir:true,ordem:index+1})) };
    },
    NormalizarLayout(modelo){
      const layout = JSON.parse(JSON.stringify(modelo || this.LayoutPadrao()));
      layout.colunas = (layout.colunas || []).map((coluna,index) => {
        const tipo = coluna.tipo || TIPO_DADOS;
        const campo = tipo === TIPO_DADOS ? coluna.campo : null;
        const identificador = coluna.identificador || campo || this.NovaChave(tipo);
        const cabecalhoPadrao = this.CabecalhoPadrao(tipo,campo);
        const cabecalhoPersonalizado = coluna.cabecalhoPersonalizado === null || coluna.cabecalhoPersonalizado === undefined
          ? cabecalhoPadrao : coluna.cabecalhoPersonalizado;
        return {...coluna,identificador,tipo,campo,cabecalhoPersonalizado,ordem:coluna.ordem || index+1};
      });
      const camposExistentes = layout.colunas.filter(x => x.tipo === TIPO_DADOS).map(x => x.campo);
      COLUNAS.filter(x => !camposExistentes.includes(x[0])).forEach(item => layout.colunas.push({
        identificador:item[0],tipo:TIPO_DADOS,campo:item[0],cabecalhoPersonalizado:item[1],exibir:false,ordem:layout.colunas.length+1
      }));
      return layout;
    },
    NormalizarVisualizacao(modelo){
      const visualizacao = modelo || {};
      const colunas = (visualizacao.colunas || []).map(coluna => typeof coluna === 'string'
        ? {identificador:coluna,cabecalho:coluna} : coluna);
      const linhas = (visualizacao.linhas || []).map(linha => {
        const chaves = Object.keys(linha);
        return colunas.reduce((resultado,coluna) => {
          const chave = chaves.find(item => item.toLocaleLowerCase('pt-BR') === coluna.identificador.toLocaleLowerCase('pt-BR'));
          resultado[coluna.identificador] = chave === undefined ? '' : linha[chave];
          return resultado;
        },{});
      });
      return {...visualizacao, colunas, linhas};
    },
    async Carregar(){
      this.carregando = true;
      try {
        const [layoutsRes,bancosRes,projetosRes] = await Promise.all([
          this.service.ObterLayouts(), new BancoService().ListarTudo(), new ProjetoService().ListarTudo()
        ]);
        this.layouts = layoutsRes.data;
        this.bancos = bancosRes.data.items || bancosRes.data;
        this.projetos = projetosRes.data.items || projetosRes.data;
        const padrao = this.layouts.find(x => x.padrao);
        if(padrao){ this.layoutSelecionadoId = padrao.id; this.layout = this.NormalizarLayout(padrao); }
        else this.NovoLayout();
      } catch(err){ this.ExibirErro(err); }
      finally { this.carregando = false; }
    },
    SelecionarLayout(id){
      const selecionado = this.layouts.find(x => x.id === id);
      this.layout = selecionado ? this.NormalizarLayout(selecionado) : this.LayoutPadrao();
      this.LimparVisualizacao();
    },
    NovoLayout(){ this.layoutSelecionadoId = null; this.layout = this.LayoutPadrao(); this.LimparVisualizacao(); },
    ModeloLayout(){ return {...this.layout, colunas:this.colunasOrdenadas.map((x,index) => ({
      identificador:x.identificador,tipo:x.tipo,campo:x.campo,cabecalhoPersonalizado:x.cabecalhoPersonalizado,exibir:x.exibir,ordem:index+1
    }))}; },
    async SalvarLayout(){
      if(!this.layout.nome || !this.layout.nome.trim()) return this.$swal('Aviso','Informe o nome do layout.','warning');
      await this.Executar(async () => {
        const res = this.layout.id ? await this.service.AtualizarLayout(this.layout.id,this.ModeloLayout()) : await this.service.SalvarLayout(this.ModeloLayout());
        await this.RecarregarLayouts(res.data.id);
        this.$swal('Aviso','Layout salvo com sucesso!','success');
      });
    },
    async SalvarComo(){
      const resultado = await this.$swal({title:'Salvar layout como',input:'text',inputLabel:'Nome do novo layout',showCancelButton:true,confirmButtonText:'Salvar',cancelButtonText:'Cancelar',inputValidator:v => !v ? 'Informe o nome.' : undefined});
      if(!resultado.value) return;
      await this.Executar(async () => {
        const modelo = this.ModeloLayout(); modelo.id = 0; modelo.nome = resultado.value; modelo.padrao = false;
        const res = await this.service.SalvarLayout(modelo); await this.RecarregarLayouts(res.data.id);
        this.$swal('Aviso','Layout criado com sucesso!','success');
      });
    },
    async ExcluirLayout(){
      const confirmacao = await this.$swal({title:'Excluir layout?',text:this.layout.nome,icon:'warning',showCancelButton:true,confirmButtonText:'Excluir',cancelButtonText:'Cancelar'});
      if(!confirmacao.value) return;
      await this.Executar(async () => { await this.service.ExcluirLayout(this.layout.id); await this.RecarregarLayouts(); this.NovoLayout(); });
    },
    async DefinirPadrao(){ await this.Executar(async () => { await this.service.DefinirPadrao(this.layout.id); await this.RecarregarLayouts(this.layout.id); }); },
    async RecarregarLayouts(selecionarId){
      const res = await this.service.ObterLayouts(); this.layouts = res.data;
      if(selecionarId){ this.layoutSelecionadoId = selecionarId; this.SelecionarLayout(selecionarId); }
    },
    InicioArraste(index,event){
      this.indiceArraste = index;
      if(event && event.dataTransfer){ event.dataTransfer.effectAllowed = 'move'; event.dataTransfer.setData('text/plain',String(index)); }
    },
    FinalArraste(index){ if(this.indiceArraste !== null) this.Reordenar(this.indiceArraste,index); this.indiceArraste = null; },
    MoverColuna(index,direcao){ this.Reordenar(index,index+direcao); },
    Reordenar(origem,destino){
      const colunas = this.colunasOrdenadas; if(destino < 0 || destino >= colunas.length) return;
      const [movida] = colunas.splice(origem,1); colunas.splice(destino,0,movida); colunas.forEach((x,i) => x.ordem=i+1); this.layout.colunas = colunas; this.LimparVisualizacao();
    },
    AdicionarColuna(tipo){
      if(tipo !== TIPO_SEQUENCIAL && tipo !== TIPO_VAZIA) return;
      if(tipo === TIPO_SEQUENCIAL && this.possuiColunaSequencial) return;
      const colunas = this.colunasOrdenadas;
      colunas.push({identificador:this.NovaChave(tipo),tipo,campo:null,cabecalhoPersonalizado:this.CabecalhoPadrao(tipo),exibir:true,ordem:colunas.length+1});
      this.layout.colunas = colunas;
    },
    RemoverColuna(identificador){
      const colunas = this.colunasOrdenadas.filter(x => x.identificador !== identificador);
      colunas.forEach((x,index) => x.ordem=index+1);
      this.layout.colunas = colunas;
    },
    NovaChave(tipo){ return `${tipo}_${Date.now()}_${Math.random().toString(36).slice(2,10)}`; },
    NomeCampo(campo){ return (COLUNAS.find(x => x[0] === campo) || [null,campo])[1]; },
    NomeTipoColuna(coluna){
      if(coluna.tipo === TIPO_SEQUENCIAL) return 'Sequencial';
      if(coluna.tipo === TIPO_VAZIA) return 'Coluna vazia';
      return 'Coluna de dados';
    },
    CabecalhoPadrao(tipo,campo){
      if(tipo === TIPO_SEQUENCIAL) return 'Sequencial';
      if(tipo === TIPO_VAZIA) return 'Coluna vazia';
      return this.NomeCampo(campo);
    },
    Request(){ return {...this.filtros, layoutNome:this.layout.nome || null, configuracao:this.ModeloLayout()}; },
    Validar(){
      if(!this.$refs.formFiltros.validate()) return false;
      if(this.filtros.dataInicial > this.filtros.dataFinal){ this.$swal('Aviso','O período inicial não pode ser maior que o final.','warning'); return false; }
      if(!this.layout.colunas.some(x => x.exibir)){ this.$swal('Aviso','Selecione ao menos uma coluna.','warning'); return false; }
      return true;
    },
    async Visualizar(){
      if(!this.Validar()) return;
      await this.Executar(async () => {
        const res = await this.service.Visualizar(this.Request());
        this.visualizacao = this.NormalizarVisualizacao(res.data);
        this.visualizacaoExecutada = true;
      });
    },
    async GerarArquivo(formato){
      if(!this.Validar()) return;
      await this.Executar(async () => {
        const res = await this.service.GerarArquivo(formato,this.Request());
        const url = window.URL.createObjectURL(new Blob([res.data])); const link = document.createElement('a'); link.href = url;
        const disposition = res.headers['content-disposition'] || ''; const match = disposition.match(/filename\*?=(?:UTF-8'')?["']?([^"';]+)/i);
        link.download = match ? decodeURIComponent(match[1]) : `Exportacao_Contabil.${formato}`; document.body.appendChild(link); link.click(); link.remove(); window.URL.revokeObjectURL(url);
        const quantidade = res.headers['x-export-record-count'] || '0';
        const nome = decodeURIComponent(res.headers['x-export-layout-name'] || encodeURIComponent(this.layout.nome || 'Sem layout salvo'));
        const horario = res.headers['x-exported-at'] ? new Date(res.headers['x-exported-at']).toLocaleString('pt-BR') : new Date().toLocaleString('pt-BR');
        this.$swal('Exportação concluída',`${quantidade} registros exportados. Layout: ${nome}. Data e hora: ${horario}.`,'success');
      });
    },
    async Executar(acao){ this.carregando = true; try { await acao(); } catch(err){ await this.ExibirErro(err); } finally { this.carregando = false; } },
    async ExibirErro(err){
      let dados = err.response ? err.response.data : null;
      if(dados instanceof Blob){ try { dados = JSON.parse(await dados.text()); } catch(e){ dados = {mensagem:'Não foi possível processar a resposta da exportação.'}; } }
      if(dados && dados.inconsistencias){ this.inconsistencias = dados.inconsistencias; this.dialogInconsistencias = true; return; }
      const mensagem = dados && (dados.mensagem || dados.title) ? (dados.mensagem || dados.title) : (typeof dados === 'string' ? dados : err.message);
      this.$swal('Aviso',mensagem || 'Não foi possível concluir a operação.','error');
    },
    LimparVisualizacao(){ this.visualizacao={colunas:[],linhas:[],quantidadeExibida:0,totalRegistros:null}; this.visualizacaoExecutada=false; }
  },
  mounted(){ this.layout = this.LayoutPadrao(); this.Carregar(); }
}
</script>

<style scoped>
.layout-gap{gap:8px}.colunas-tabela::v-deep .v-data-table__wrapper{max-height:560px;overflow:auto;-webkit-overflow-scrolling:touch}.colunas-tabela::v-deep table{min-width:900px}.colunas-tabela::v-deep th{white-space:nowrap}.colunas-tabela::v-deep td{height:64px;padding-top:8px!important;padding-bottom:8px!important;vertical-align:middle}.colunas-tabela::v-deep td:nth-child(3) .v-input{max-width:480px}.coluna-switch{display:inline-flex;margin-top:0!important;padding-top:0!important}.drag-handle{display:inline-flex;cursor:grab;padding:8px}.drag-handle:active{cursor:grabbing}.inconsistencias-scroll{width:100%;max-width:100%}.inconsistencias-tabela::v-deep .v-data-table__wrapper{width:100%;overflow-x:auto!important;-webkit-overflow-scrolling:touch}.inconsistencias-tabela::v-deep table{width:1600px!important;min-width:1600px!important}@media(max-width:600px){.v-card__actions .v-btn{flex:1 1 45%;margin:2px!important}}
</style>
